export const userConst = {
    REGISTER_REQUEST: 'USER_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USER_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

    CHANGE_REQUEST: 'USER_CHANGE_REQUEST',
    CHANGE_SUCCESS: 'USER_CHANGE_SUCCESS',
    CHANGE_FAILURE: 'USER_CHANGE_FAILURE',

    CLEAR_ERRORS: 'USER_CLEAR_ERRORS',

    LOGOUT: 'USERS_LOGOUT'
};
